/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { campaignsCreateCampaignGet } from '../fn/campaigns/campaigns-create-campaign-get';
import { CampaignsCreateCampaignGet$Params } from '../fn/campaigns/campaigns-create-campaign-get';
import { campaignsCreateCampaignPost } from '../fn/campaigns/campaigns-create-campaign-post';
import { CampaignsCreateCampaignPost$Params } from '../fn/campaigns/campaigns-create-campaign-post';
import { campaignsDelete } from '../fn/campaigns/campaigns-delete';
import { CampaignsDelete$Params } from '../fn/campaigns/campaigns-delete';
import { campaignsGetCampaignById } from '../fn/campaigns/campaigns-get-campaign-by-id';
import { CampaignsGetCampaignById$Params } from '../fn/campaigns/campaigns-get-campaign-by-id';
import { campaignsGetCampaignsAudit } from '../fn/campaigns/campaigns-get-campaigns-audit';
import { CampaignsGetCampaignsAudit$Params } from '../fn/campaigns/campaigns-get-campaigns-audit';
import { campaignsGetCampaignsWithPagination } from '../fn/campaigns/campaigns-get-campaigns-with-pagination';
import { CampaignsGetCampaignsWithPagination$Params } from '../fn/campaigns/campaigns-get-campaigns-with-pagination';
import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetCampaignByIdDto } from '../models/custom-result-of-get-campaign-by-id-dto';
import { CustomResultOfInteger } from '../models/custom-result-of-integer';
import { CustomResultOfPaginatedListOfGetCampaignsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-campaigns-with-pagination-dto';

@Injectable({ providedIn: 'root' })
export class CampaignsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `campaignsCreateCampaignGet()` */
  static readonly CampaignsCreateCampaignGetPath = '/Campaigns/CreateCampaign';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `campaignsCreateCampaignGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  campaignsCreateCampaignGet$Response(params?: CampaignsCreateCampaignGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return campaignsCreateCampaignGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `campaignsCreateCampaignGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  campaignsCreateCampaignGet(params?: CampaignsCreateCampaignGet$Params, context?: HttpContext): Observable<Blob> {
    return this.campaignsCreateCampaignGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `campaignsCreateCampaignPost()` */
  static readonly CampaignsCreateCampaignPostPath = '/Campaigns/CreateCampaign';

  /**
   * ثبت کمپین.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `campaignsCreateCampaignPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  campaignsCreateCampaignPost$Response(params: CampaignsCreateCampaignPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfInteger>> {
    return campaignsCreateCampaignPost(this.http, this.rootUrl, params, context);
  }

  /**
   * ثبت کمپین.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `campaignsCreateCampaignPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  campaignsCreateCampaignPost(params: CampaignsCreateCampaignPost$Params, context?: HttpContext): Observable<CustomResultOfInteger> {
    return this.campaignsCreateCampaignPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfInteger>): CustomResultOfInteger => r.body)
    );
  }

  /** Path part for operation `campaignsDelete()` */
  static readonly CampaignsDeletePath = '/Campaigns/{id}';

  /**
   * حذف کمپین.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `campaignsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  campaignsDelete$Response(params: CampaignsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return campaignsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف کمپین.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `campaignsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  campaignsDelete(params: CampaignsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.campaignsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `campaignsGetCampaignsWithPagination()` */
  static readonly CampaignsGetCampaignsWithPaginationPath = '/Campaigns/GetCampaignsWithPagination';

  /**
   * Get Campaigns With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `campaignsGetCampaignsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  campaignsGetCampaignsWithPagination$Response(params: CampaignsGetCampaignsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetCampaignsWithPaginationDto>> {
    return campaignsGetCampaignsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Campaigns With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `campaignsGetCampaignsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  campaignsGetCampaignsWithPagination(params: CampaignsGetCampaignsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetCampaignsWithPaginationDto> {
    return this.campaignsGetCampaignsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetCampaignsWithPaginationDto>): CustomResultOfPaginatedListOfGetCampaignsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `campaignsGetCampaignById()` */
  static readonly CampaignsGetCampaignByIdPath = '/Campaigns/GetCampaignById';

  /**
   * Get Campaign By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `campaignsGetCampaignById()` instead.
   *
   * This method doesn't expect any request body.
   */
  campaignsGetCampaignById$Response(params?: CampaignsGetCampaignById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetCampaignByIdDto>> {
    return campaignsGetCampaignById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Campaign By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `campaignsGetCampaignById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  campaignsGetCampaignById(params?: CampaignsGetCampaignById$Params, context?: HttpContext): Observable<CustomResultOfGetCampaignByIdDto> {
    return this.campaignsGetCampaignById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetCampaignByIdDto>): CustomResultOfGetCampaignByIdDto => r.body)
    );
  }

  /** Path part for operation `campaignsGetCampaignsAudit()` */
  static readonly CampaignsGetCampaignsAuditPath = '/Campaigns/GetCampaignsAudit';

  /**
   * Only for super admin, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `campaignsGetCampaignsAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  campaignsGetCampaignsAudit$Response(params: CampaignsGetCampaignsAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return campaignsGetCampaignsAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `campaignsGetCampaignsAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  campaignsGetCampaignsAudit(params: CampaignsGetCampaignsAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.campaignsGetCampaignsAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

}
